import React, { FC } from 'react';

import BorrowerDetailsPopUp from 'components/curo-components/common/BorrowerDetailsPopUp';
import { getBorrowerDetails } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import CuroMainLayout from 'layout/CuroMainLayout';
import { ICuroMainLayoutProps } from 'layout/CuroMainLayout/CuroMainLayout';
import { logout } from 'thunks';

type CuroAuthorizedLayoutProps = Omit<ICuroMainLayoutProps, 'borrowerDetails'>;

const CuroAuthorizedLayout: FC<CuroAuthorizedLayoutProps> = ({ children, ...mainLayoutProps }) => {
  const { phone, email, firstName, lastName } = useAppSelector(getBorrowerDetails);
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const handleLogout = async () => {
    await dispatchWithUnwrap(logout());
  };

  return (
    <CuroMainLayout
      borrowerDetails={
        <BorrowerDetailsPopUp
          borrowerName={`${firstName} ${lastName}`}
          borrowerEmail={email}
          borrowerPhone={phone}
          onLogoutClick={handleLogout}
        />
      }
      {...mainLayoutProps}
    >
      {children}
    </CuroMainLayout>
  );
};

export default CuroAuthorizedLayout;
